import React, { useContext, useEffect } from "react";
import "./Articles.css";
import "./responsiveArticles.css";
import FooterTwo from "../../components/footerTwo/FooterTwo";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey, truncate } from "../../helper/function";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../components/loadingPage/LoadingPage";
import ScrollAnimation from "react-animate-on-scroll";

const Articles = () => {
  const { isLoadingNews, allNews, homeNews, allWebParts } =
    useContext(dataContext);
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const filterNews = allWebParts?.filter((x) => x.uniqueName === "news");
  let delay = 0;
  let delay2 = 0;
  return (
    <>
      {isLoadingNews ? (
        <LoadingPage />
      ) : (
        <div className="articles">
          <div className="content">
            <div className="left">
              <p>
                <span>اخبار</span> آرد زر
              </p>
              <span className="span">
                {filterKey(filterNews, "description")?.map(
                  (item) => item.Value
                )}
              </span>
            </div>
            <div className="right">
              <img src="/pic/flourScope.png" alt="scope flour" />
            </div>
          </div>

          <div className="box-articles">
            <div className="card-container">
              {allNews &&
                allNews?.items?.map((item, index) => {
                  delay = delay + 250;
                  return (
                    <ScrollAnimation
                      animateIn="zoomIn"
                      delay={delay}
                      key={index}
                    >
                      <div
                        className="cardd"
                        onClick={() =>
                          navigateHandler(
                            `/newsDetail/${item.id}/${item.seoUrlTitle}`
                          )
                        }
                      >
                        <div className="img-container">
                          <img
                            src={`${
                              window.Configs["ui-base-url"]
                            }/Api/V1/ui/Content/Image?entityName=2&imageName=${
                              item?.image && item?.image
                            }`}
                            alt="pic-news"
                          />
                        </div>
                        <div className="contentt">
                          <p className="p">{truncate(item.title, 65)}</p>
                          <p className="span">{truncate(item.summary, 140)}</p>
                          <span className="date">{item.createDate}</span>
                        </div>
                      </div>
                    </ScrollAnimation>
                  );
                })}
            </div>
            <div className="recent">
              <div className="recent-card">
                <p className="title">خبرهای اخیر</p>
                {homeNews &&
                  homeNews?.map((item, index) => {
                    delay2 = delay2 + 250;
                    return (
                      <ScrollAnimation
                        // animateIn="bounceIn"
                        // animateIn="bounceInLeft"
                        // animateIn="zoomIn"
                        animateIn="fadeInLeft"
                        delay={delay2}
                        className="items"
                        key={index}
                      >
                        <p>{item?.title}</p>
                        <span>{item?.createDate}</span>
                      </ScrollAnimation>
                    );
                  })}
              </div>
            </div>
          </div>

          <FooterTwo />
        </div>
      )}
    </>
  );
};

export default Articles;
